class SubscriberSearchController extends BaseSearchController
	@register()
	@inject 'BACKEND_SUBSCRIBER_ENTITY_TYPE',
		'ConfigurationService'

	initialize: ->
		@items = null
		@useStaticItems = true

		super()

	getItems: ->
		if @items != null
			return @items

		configurationMap =
			"#{@BACKEND_SUBSCRIBER_ENTITY_TYPE.DAY_TALLY}": 'Backoffice.TopMenu.Report.Eod'
			"#{@BACKEND_SUBSCRIBER_ENTITY_TYPE.SAFT}": [
				'OR',
				'Shared.Setting.SaftNoCrReport.Enabled',
				'Shared.Setting.SaftPtReport.Enabled']
			"#{@BACKEND_SUBSCRIBER_ENTITY_TYPE.SALES_REPORT}": 'Backoffice.TopMenu.Report.SalesReport'

		@items = _.map(
			@BACKEND_SUBSCRIBER_ENTITY_TYPE,
			(type) =>
				isEnabled = true

				if configurationMap[type]?
					isEnabled = @ConfigurationService.isEnabled(configurationMap[type])

				return {
					id: type
					enabled: isEnabled
					name: 'wbo.subscriber.type.' + type.toLowerCase()
				}
		)

		@items = _.reject(@items, {enabled: false})

		return @items
